// extracted by mini-css-extract-plugin
module.exports = {"Map":"Map_Map__lBUCh","clusterIcon":"Map_clusterIcon__1ncL6","markerLabel":"Map_markerLabel__LeGlu","loader":"Map_loader__1zewN"};